import React from 'react';
import BrowseLocality from '@domain-group/fe-pa-allhomes-browse-suburb';
import StandardPage from './common/standard-page.js';

export default (props) => (
  <StandardPage component={BrowseLocality} {...props} />
);
